import React from "react";
import robotImage from "../../assets/images/ai-robot.png";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    // Set a light background for the whole section to ensure contrast
    <main className="bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 overflow-hidden">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Column (Text Content) */}
          <div className="relative z-10">
            <p className="text-sm uppercase text-cyan-500 font-semibold tracking-wider mb-3">
              A GROWING TREND FOR THE NEXT 10 YEARS
            </p>
            <h1 className="text-5xl md:text-6xl font-extrabold text-slate-800 leading-tight mb-8">
              Create an AI employee for your business
            </h1>

            {/* Feature Bubbles */}
            <div className="space-y-4 mb-10">
              <div className="bg-white p-4 rounded-xl shadow-lg border border-slate-200 flex items-center space-x-3 max-w-sm ml-auto">
                <div className="flex-shrink-0 bg-blue-100 rounded-full p-2">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <p className="text-slate-700">
                  Available 24/7 to any online worker
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-lg border border-slate-200 flex items-center space-x-3 max-w-md ml-8">
                <div className="flex-shrink-0 bg-blue-100 rounded-full p-2">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <p className="text-slate-700">
                  Easily created on our platform, boosts sales
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="flex items-center space-x-6">
              <button 
              onClick={()=> navigate("/signup")}
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-4 px-8 rounded-lg shadow-lg shadow-blue-500/30 transition-transform transform hover:scale-105">
                TRY FOR FREE
              </button>
              <div className="text-slate-600 text-sm">
                <p className="font-semibold">14-day free trial</p>
                <p>for every user</p>
              </div>
            </div>
            <p className="mt-6 text-sm text-slate-500">
              Have an account?{" "}
              <a
                href="/login"
                className="text-cyan-500 font-semibold hover:underline"
              >
                Log in
              </a>
            </p>
          </div>
          {/* Right Column (Image) */}
          <div className="relative">
            {/* Decorative Background Blobs */}
            <div className="absolute -top-20 -right-20 w-80 h-80 bg-orange-200 rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-blob"></div>
            <div className="absolute top-20 -left-10 w-72 h-72 bg-yellow-200 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-blob animation-delay-2000"></div>

            {/* AI Generated Image */}
            <div className="relative z-10">
              <img
                src={robotImage}
                alt="AI employee robot working at a desk"
                className="w-full h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default HeroSection;
